import React from 'react';
export const Refresh = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.20498 2.3002H10.8011C12.2958 2.3002 13.5031 3.50644 13.5031 5.00397V10.3878H15.303V5.00397C15.303 2.51207 13.2896 0.5 10.8013 0.5H7.20517L7.20498 2.3002ZM10.8011 16.6998H7.20498C5.71562 16.6998 4.50302 15.486 4.50302 14V9.49985H2.70313V14C2.70313 16.4798 4.72118 18.4997 7.20478 18.4997H10.8009L10.8011 16.6998Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.23648 8.36715C3.88497 8.01564 3.31513 8.01564 2.96363 8.36715L0.263634 11.0671C-0.087878 11.4185 -0.087878 11.9883 0.263634 12.3398C0.615146 12.6913 1.18499 12.6914 1.53649 12.3398L3.60005 10.3534L5.66362 12.3398C6.01513 12.6914 6.58497 12.6914 6.93647 12.3398C7.28797 11.9883 7.28798 11.4185 6.93647 11.0671L4.23648 8.36715Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4008 9.25201L12.3373 7.26559C11.9858 6.91408 11.4159 6.91408 11.0644 7.26559C10.7129 7.6171 10.7129 8.18694 11.0644 8.53829L13.7644 11.2383C14.1159 11.5898 14.6858 11.5898 15.0373 11.2383L17.7372 8.53829C18.0888 8.18692 18.0888 7.61709 17.7372 7.26559C17.3857 6.91409 16.8159 6.91408 16.4644 7.26559L14.4008 9.25201Z"
        fill="currentColor"
      />
    </svg>
  );
};
